// extracted by css-extract-rspack-plugin
export default {"task-responsible-inline-editor":"task-responsible-inline-editor-C2gQJd","taskResponsibleInlineEditor":"task-responsible-inline-editor-C2gQJd"};